import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonials = [
  {
    img: "https://images.unsplash.com/photo-1770627000564-3feb36aecbcd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBidXNpbmVzcyUyMG93bmVyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg1OTE3MTM5fDA&ixlib=rb-4.1.0&q=85",
    quote:
      "We went from zero marketplace presence to live on Amazon and Blinkit in under two weeks. The listings looked like a brand ten times our size.",
    name: "Priya M.",
    role: "Founder, D2C Skincare Brand",
  },
  {
    img: "https://images.unsplash.com/photo-1695391396401-5fbb4bedafc1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBidXNpbmVzcyUyMG93bmVyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg1OTE3MTM5fDA&ixlib=rb-4.1.0&q=85",
    quote:
      "Quick commerce felt impossible for a regional FMCG brand like ours. They handled the GTINs, the POs, the follow-ups — we just kept shipping.",
    name: "Rohan K.",
    role: "Director, Family FMCG Business",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-28 lg:py-40 bg-ink border-y border-coal/10"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="flex items-start justify-between mb-16 lg:mb-24">
          <div>
            <motion.span
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-xs font-bold uppercase tracking-[0.25em] text-coal/40"
            >
              05 — Voices
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="font-display font-900 tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-xl"
            >
              Founders who{" "}
              <span className="font-accent italic font-medium text-terracotta">
                made the leap.
              </span>
            </motion.h2>
          </div>
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="hidden lg:block font-display font-900 text-8xl text-outline-gold select-none"
          >
            05
          </motion.span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.15,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="group border border-coal/10 p-8 lg:p-12 hover:border-terracotta/40 transition-colors duration-500"
            >
              <Quote size={32} className="text-gold" fill="currentColor" strokeWidth={0} />
              <blockquote className="mt-6 font-display font-500 text-xl sm:text-2xl leading-snug text-coal/85">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-10 flex items-center gap-5">
                <div className="w-14 h-14 overflow-hidden">
                  <img
                    src={t.img}
                    alt={t.name}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 scale-110 group-hover:scale-100 transition-all duration-700"
                  />
                </div>
                <div>
                  <div className="font-bold text-sm">{t.name}</div>
                  <div className="text-xs uppercase tracking-[0.15em] text-coal/45 mt-1">
                    {t.role}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
